module.exports = __webpack_public_path__ + "img/zixun_banner.b44a2bc6.png";